<template>
  <v-container fluid grid-list-md fill-height style="padding-top: 8px;">
    <LogButton
        style="
          top: -3rem;
          right: 1rem;
          position: absolute;
          color:white;
          background-color: rgb(51,82,128);
          border-radius: 8px;
        "
        :file="'faults'"
        :output="'faults-designation'"
        :notification_table="'faults'"
    />
    <v-layout row style="width: 100%; height: 100%">
      <v-flex d-flex md12>
        <v-layout column>
          <v-flex d-flex md12>
            <v-layout column>
              <v-flex d-flex style="height: 3rem; max-height: 3rem; align-items: center;">
                <h3>Acknowledged faults
                  <a>
                    <font-awesome-icon
                        title="KPI: 1 daily occurrence per fault is acceptable. KPI resets every cal. month"
                        style="color: #ffb81d"
                        icon="circle-info"
                    />
                  </a>
                </h3>
                <ul
                    style="
                    background-color: rgb(51,82,128);
                    border-radius: 8px;
                    color: white;
                    display: inline-flex;
                    margin: 0;
                    padding: 2px 16px 2px 0px ;
                    width: fit-content;
                    max-width: fit-content;
                    list-style: none;
                  "
                >
                  <li style="display: inline-flex; margin-left: 8px">
                    <ColorRadioV2
                        :id="''"
                        :selected="0"
                        :items="status_items"
                        :callback="null"
                        :offset_left="'0px'"
                        :noChange="true"
                        style="padding-top: 2px"
                    />
                    <span style="padding-left: 0px">False</span>
                  </li>
                  <li style="display: inline-flex; margin-left: 8px">
                    <ColorRadioV2
                        :id="''"
                        :selected="1"
                        :items="status_items"
                        :callback="null"
                        :offset_left="'0px'"
                        :noChange="true"
                        style="padding-top: 2px"
                    />
                    <span style="padding-left: 0px">Verified</span>
                  </li>
                </ul>
              </v-flex>
              <v-flex d-flex md12 style="overflow-y: auto;">
                <FaultsCollapsableTableWithHeaderFilters
                    ref="faultGroupsTable"
                    :verified="true"
                    :kpis="true"
                    :status_items="status_items"
                    :pendingUpdatesFlag.sync="pendingFaultUpdates"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md1 style="padding-left: 0; align-self: end;">
            <v-layout row>
              <v-flex d-flex md1 style="padding-left: 0; text-align: right">
                <v-btn
                    v-if="updateAllowed"
                    :disabled="!pendingFaultUpdates"
                    style="color:white; background-color: rgb(51,82,128);"
                    @click="openPendingFaultsDialog"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <PendingFaultsDialog
        ref="saveFaultsDialog"
        :pending_updates="pending_updates"
        :callback="reloadInstancesSource"
    />
  </v-container>
</template>

<script>

import ColorRadioV2 from "@/components/ColorRadioV2";
import LogButton from "@/components/LogButton";
import {store} from "@/main";
import FaultsCollapsableTableWithHeaderFilters from "@/components/faults/FaultsCollapsableTableWithHeaderFilters";
import PendingFaultsDialog from "@/components/faults/PendingFaultsDialog";

export default {
  name: "AcknowledgedFaultsTable",
  components: {
    LogButton,
    ColorRadioV2,
    FaultsCollapsableTableWithHeaderFilters,
    PendingFaultsDialog
  },
  data() {
    return {
      status_items: [
        {
          'value': 0,
          'color': 'red',
          'label': 'False'
        },
        {
          'value': 1,
          'color': 'green',
          'label': 'Verified'
        }
      ],
      pending_updates: {},
      pendingFaultUpdates: false
    }
  },
  methods: {
    getPeriod() {
      let period;

      switch (store.type) {
        case 'month':
          period = '1month'
          break;
        case 'threemonths':
          period = '3months'
          break;
        case 'sixmonths':
          period = '6months'
          break;
        case 'twelvemonths':
          period = '12months'
          break;
      }

      return period;
    },
    openPendingFaultsDialog() {
      this.$refs.saveFaultsDialog.openDialog()
    },
    reloadInstancesSource() {
      this.$refs.faultGroupsTable.reloadInstancesSource()
    },
    toggleSaveBtn() {
      this.pendingFaultUpdates = Object.keys(this.pending_updates).length > 0;
    },
  },
  computed: {
    updateAllowed: () => {
      let admin = store.userProfile.roles.filter((item) => {
        return item.toLowerCase().indexOf('admin') > -1
      }).length > 0;

      return admin
    }
  },
  watch: {
    pendingFaultUpdates: function () {
      console.log(this.$refs.faultGroupsTable.pending_updates);
      this.pending_updates = this.$refs.faultGroupsTable.pending_updates;
    }
  }
}
</script>